export default "<div class=\"footer-wrap\">\n  <div class=\"container\">\n    © Copyright 2022. All Rights are Reserved.\n  </div>\n</div>\n"